import { useParams } from "react-router-dom";
import Button from "components/Buttons/Button/Button";
import MainCard from "components/layout/MainCard/MainCard";
import Sitemap from "routes/sitemap";
import StaticPage from "../../components/StaticPage/StaticPage";
import background from "../../assets/images/backgrounds/checkmark-transparent.png";
import scss from "./CheckoutSuccess.module.scss";
import { useTranslation } from "react-i18next";

const CheckoutSuccess = () => {
    const { t } = useTranslation();

    const { orderId } = useParams();
    return (
        <MainCard>
            <div className="page-container">
                <div className={`p page-content ${scss.container}`} style={{ backgroundImage: `url(${background})` }}>
                    <h2>{t("cart_success-default-title")}</h2>
                    <p>{t("cart_success-default-introduction")},</p>
                    <p>
                        {t("cart_success-default-p1")}
                        <br />
                        {t("cart_success-default-p2")} #{orderId}
                    </p>
                    <StaticPage slug={"cart_success-default-page"} />
                    <Button to={Sitemap.contact._} label={"cart_success-default-contact_link"} />
                </div>
            </div>
        </MainCard>
    );
};

export default CheckoutSuccess;
